import { Box } from '@mui/material'
import { ForPayment } from './ForPayment'
import { Paid } from './Paid'
import { SnakeLoader } from '../../../../core/loader/SnakeLoader';
import Currency from 'react-currency-format';
import NotFound from '../../../../assets/images/empty/new-empty-box.png';

export const List = ({urlparams, payment_state, subdir, tool_state}) => {
    const { openView, record, paidView } = payment_state
    
    return (
        <>
            {
                record.data.loader ? (
                    <Box component="strong" height="100%" display="flex" justifyContent="center" alignItems="center">
                        <SnakeLoader size="10px" bg="#11783C" distance="0.3rem" />
                    </Box>
                ):(
                    record.data.list.length !== 0 ? (
                        <> 
                            {

                                urlparams.get('tab') === 'for-payment' ?(
                                    <ForPayment record={record} subdir={subdir} />

                                ):(
                                    <Paid openView={openView} record={record} subdir={subdir} tool_state={tool_state} paidView={paidView} />
                                )
                            }
                            <Box display="Flex" justifyContent="flex-end" mb={10}>
                                <Box display="flex" flexDirection="column" gap="16pxs" >
                                    {
                                        urlparams.get('tab') === 'for-payment' &&
                                            <>
                                                <Box display="flex" alignItems="center" justifyContent="space-between" gap="40px">
                                                    <Box>Total Sales</Box>
                                                    <Currency value= {record.data.total_sales.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} />
                                                </Box>
                                                <Box display="flex" alignItems="center" justifyContent="space-between"  gap="40px">
                                                    <Box>Total Fees</Box>
                                                    <Currency value= {record.data.total_fees.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} />
                                                </Box>
                                            </>
                                    }
                                    <Box display="flex" alignItems="center"  gap="40px" component="b">
                                        <Box>Total Net Amount</Box>
                                        <Currency value= {record.data.total_net_amount.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} />
                                    </Box>
                                </Box>
                            </Box>
                        </>
                            
                    ):(
                        <Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center" p={2} border="1px solid" borderRadius="16px">
                            <Box component="b" fontSize={{sm: 16, md: 18, lg: 24}}>
                                No Sales Yet for Payment Processing
                            </Box>
                            <Box component="img" alt="Not Found" src={NotFound} pt={2} />
                        </Box>
                    )
                )
            }
        </>
    )
}
